import * as React from 'react';

import { ITargetCheckProps } from './types';

import { useSettings } from './useSettings';
import { useRunCheck } from './useRunCheck';
import { Icons, Button, Checkbox, DateInput } from 'src/components';

const today = new Date();

export const TargetCheck: React.FC<ITargetCheckProps> = ({ link, onRun }) => {
  const { settings, actions } = useSettings(link);
  const { isRunning, runCheck } = useRunCheck(link, onRun);

  return (
    <div className="flex items-center relative">
      <div className="button-group flex">
        <Button
          primary={true}
          size="small"
          background="grey"
          onClick={runCheck}
          loading={isRunning}
          loadingLabel="Running check"
        >
          Target check
        </Button>
        <Button
          icon={true}
          primary={true}
          size="small"
          background="grey"
          onClick={actions.toggleOpen}
          loading={settings.isFetching}
          disabled={settings.isFetching}
        >
          <Icons.Edit size={20} />
        </Button>
      </div>
      {settings.isOpen && (
        <div className="tooltip tooltip--bottom absolute z-30 w-64 bg-white shadow-md border border-grey-dark text-left py-3 px-3">
          <Checkbox
            className="mb-4"
            secondary={true}
            name="isActive"
            checked={settings.isActive}
            onChange={actions.toggleActive}
          >
            Check daily
          </Checkbox>
          <div className={settings.isActive ? '' : 'opacity-50'}>
            <div className="flex items-center mb-3">
              <span className="w-24">From</span>
              <DateInput
                className="flex-1"
                small={true}
                secondary={true}
                selected={settings.dateFrom || new Date()}
                onChange={actions.setDate('DATE_FROM')}
                minDate={today}
                disabled={!settings.isActive}
              />
            </div>
            <div className="flex items-center mb-4">
              <span className="w-24">To</span>
              <DateInput
                className="flex-1"
                small={true}
                secondary={true}
                selected={
                  settings.dateTo < settings.dateFrom
                    ? settings.dateFrom
                    : settings.dateTo
                }
                onChange={actions.setDate('DATE_TO')}
                minDate={settings.dateFrom || undefined}
                disabled={!settings.isActive}
              />
            </div>
          </div>
          <Button
            size="small"
            onClick={actions.saveSettings}
            loading={settings.isSaving}
            loadingLabel="Saving"
          >
            Save
          </Button>
          {settings.savingError && (
            <p className="inline ml-3 text-red">Error, try again.</p>
          )}
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/TargetCheck/components/TargetCheck/TargetCheck.tsx